/**
 * portal-layout.js - Dashboard layout component.
 *
 * This is used to provide the default portal layout for all standard views
 * that contain portal-related content.
 *
 * @author Alex Symeonidis
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import Sidebar from "../container/sidebar/sidebar";

import "@fortawesome/fontawesome-free/css/all.css";
import ProfileMenu from "../component/profile-menu";

class PortalLayout extends Component {
  render() {
    const children = this.props.children;
    let startYear = 2020;
    let currentYear = new Date().getFullYear();
    let copyrightYear = "2020";
    if (currentYear !== startYear) {
      copyrightYear = "2020-" + currentYear;
    }

    return (
      <div id={"wrapper"}>
        {/* Loads the sidebar. */}
        <Sidebar/>

        {/* Content Wrapper. This wraps the entire content view. */}
        <div id={"content-wrapper"} className="d-flex flex-column">
          <div id={"content"} style={{display:"flex", flexDirection: "column"}}>
            {/* Topbar */}
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

              {/* Topbar Navbar */}
              <ul className="navbar-nav ml-auto">
                <div className="topbar-divider d-none d-sm-block"/>
                <ProfileMenu/>
              </ul>
            </nav>
          {children}
          </div>

          {/*} Footer */}
          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>&copy;{copyrightYear} R.E.A.L. Science</span>
              </div>
            </div>
          </footer>
          {/* End of Footer */}
        </div>
        {/* End of Page Wrapper */}
      </div>
    );
  }
}

PortalLayout.propTypes = {
  children: PropTypes.element.isRequired
};

export default PortalLayout;